module.exports = __webpack_public_path__ + "img/2019qinglongxia-6.fcb2dfdd.jpg";